import { Lock } from "lucide-react";
import { NavLink } from "react-router-dom";
import { SidebarMenuItem, SidebarMenuButton } from "@/components/ui/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useModuleFeatureAccess } from "@/hooks/useTenantFeatureAccess";

interface SidebarFeatureItemProps {
  title: string;
  url: string;
  featureCode: string;
  requiredPlan: "Professional" | "Enterprise";
  isActive: boolean;
}

export function SidebarFeatureItem({
  title,
  url,
  featureCode,
  requiredPlan,
  isActive,
}: SidebarFeatureItemProps) {
  const { hasModuleFeature, isLoading } = useModuleFeatureAccess(featureCode);

  // While loading or if feature is enabled, render nothing (caller renders normally)
  if (isLoading || hasModuleFeature) return null;

  // Feature is locked — show grayed out with lock icon
  return (
    <SidebarMenuItem>
      <Tooltip>
        <TooltipTrigger asChild>
          <SidebarMenuButton
            size="default"
            className="h-9 text-sm text-sidebar-foreground/70 cursor-not-allowed hover:bg-transparent hover:text-sidebar-foreground/70"
          >
            <div className="flex items-center justify-between w-full">
              <span>{title}</span>
              <Lock className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
            </div>
          </SidebarMenuButton>
        </TooltipTrigger>
        <TooltipContent side="right" className="max-w-[200px]">
          <p className="text-xs">
            <span className="font-semibold">{title}</span> is available on the{" "}
            <span className="font-semibold text-primary">{requiredPlan}</span> plan.
          </p>
        </TooltipContent>
      </Tooltip>
    </SidebarMenuItem>
  );
}
